import { TranslateFunction } from '@/utils/translate/translate-client'

export const getYoungWashingtonConfig = (t: TranslateFunction) => {
  return {
    grandPrizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1751042810/young-washington/yw-prize-temp-Truck.png',
        alt: 'Classic Ford F250 Pickup',
        title: 'Classic Ford F250 Pickup',
        value: '$25,000',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1751042811/young-washington/yw-prize-tempRed_Carpet.png',
        alt: 'Young Washington Red Carpet Experience',
        title: 'Young Washington Red Carpet Experience',
        value: '$3,000',
      },
    ],
    firstPlacePrizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1751042811/young-washington/yw-prize-tempRed_Carpet.png',
        alt: 'Young Washington Red Carpet Experience',
        title: 'Young Washington Red Carpet Experience',
        value: '$3,000',
      },
    ],
    secondPlacePrizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1751042811/young-washington/yw-prize-tempHat.png',
        alt: 'Commemorative Young Washington Hat',
        title: 'Commemorative Young Washington Hat',
        value: '$25',
      },
    ],
    numberOfWinners: {
      firstPlace: 'four (4)',
      secondPlace: 'One-thousand (1,000)',
    },
    grandPrizeText: t(
      'grandPrizeItemsDescriptionCustom',
      'One lucky winner will win over $28,000 in prizes including a classic Ford F250 truck (perfect for America’s 250th birthday), and a trip for two to the Young Washington premiere.',
    ),
    firstPlaceText: t(
      'firstPlaceDescriptionCustom',
      'Four additional winners will receive a trip for two to the red carpet premiere of Young Washington—including airfare, hotel, ground transportation and spending money, worth over $3,000 for each winner.',
    ),
    secondPlaceText: t(
      'secondPlaceDescriptionCustom',
      'One-thousand (1000) others will win an exclusive Young Washington commemorative hat with “Rising Son” logo as seen on Uncle Sam in the giveaway video. Each hat is worth $25 retail, but priceless in showing your support for the Young Washington story and the freedom we enjoy as Americans.',
    ),
  }
}
